import { api } from './client';
import type { AuthResponse, RegisterResponse } from './types';

export function login(email: string, password: string) {
  return api<AuthResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export function register(
  empresa: string,
  slug: string,
  nombre: string,
  email: string,
  password: string
) {
  return api<RegisterResponse>('/register', {
    method: 'POST',
    body: JSON.stringify({ empresa, slug, nombre, email, password }),
  });
}
